import { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { showDate, encodeValue, hasPermission } from "../../Settings/Settings";
import { baseUrl, downloadUrl } from "../../Settings/Config";
import noImage from "../../../assets/images/faces/1.jpg";
const moduleID = 13;
class Personal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoUrl: null,
      candidateDetails: "",
    };
    this.checkImages();
  }
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `/candidate/edit`,
      state: { editID: encodeValue(editID) },
    });
  }
  componentDidMount() {}
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.candidateDetails !== nextProps.candidateDetails) {
      this.setState({ candidateDetails: nextProps.candidateDetails }, () => {
        this.checkImages();
      });
    }
  }
  checkImages() {
    const photos = this.state.candidateDetails.photos ? `${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}` : null;
    if (photos !== "" && photos !== null) {
      fetch(`${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}`, {
        method: "HEAD",
      })
        .then((res) => {
          if (res.ok) {
            this.setState({ photoUrl: `${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}` });
          } else {
          }
        })
        .catch(() => {
          console.log("❌ Error — server unreachable or CORS blocked");
        });
    }
  }

  copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied!");
      })
      .catch((err) => {
        console.error("Copy failed: ", err);
      });
  };

  viewResume(e) {
    e.preventDefault();
    const slectedPDF_ = this.state.candidateDetails.resume ?? "";
    if (slectedPDF_ !== "") {
      const slectedPDFSplit_ = slectedPDF_.split(".");
      const resumeType = slectedPDFSplit_[slectedPDFSplit_.length - 1].toLowerCase();
      this.setState({ resumeType: resumeType }, () => {
       /*  if (resumeType === "pdf") {
          $("#viewResume").trigger("click");
        } else { */
          window.open(`${downloadUrl}views/public/files/resume/${slectedPDF_}`, "_blank");
       /*  } */
      });
    }
  }

  render() {
    const cDetails = this.state.candidateDetails;
    return (
      <div className="emptablelist">
        <div className="tablediv">
          <button class="btn btn-secondary bg-secondary-gradient mt-3" data-bs-toggle="modal" data-bs-target="#extralargemodal" id="viewResume" style={{ display: "none" }}>
            Extralarge Modal
          </button>
          <div className="bg-white rounded-md shadow-sm">
            <div className="flex justify-between items-center border-b view-details-title">
              <h2 className="text-lg font-semibold text-gray-800 text-primary">
                <b>Personal Info</b>
              </h2>
              {hasPermission(moduleID, "edit") && (
                <a href="/" onClick={this.edit.bind(this, cDetails.candidateId)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-edit"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </a>
              )}
            </div>
            <div className="p-4">
              <div className="row">
                <div className="col-md-10 col-xl-10">
                  <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
                    <div>
                      <div className="text-xs text-gray-500 mb-1">First Name - Mid Name (As in Passport)</div>
                      <div className="text-sm font-medium">
                        {cDetails?.fname} {cDetails?.lname}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Rank Experience</div>
                      <div className="text-sm font-medium">{cDetails?.c_rank}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Nationality</div>
                      <div className="text-sm font-medium">{cDetails?.nationalityName}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Marital Status</div>
                      <div className="text-sm font-medium">{cDetails?.m_status || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Date Of Birth</div>
                      <div className="text-sm font-medium">{showDate(cDetails?.dob)}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Birth Place</div>
                      <div className="text-sm font-medium">{cDetails?.birth_place || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Worked with us</div>
                      <div className="text-sm font-medium">{cDetails?.work_nautilus || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Vessel Type</div>
                      <div className="text-sm font-medium">{cDetails?.c_vessel || ""}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">INDOS Number</div>
                      <div className="text-sm font-medium">{cDetails?.indos_number || ""}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Experience</div>
                      <div className="text-sm font-medium">{cDetails?.experience || ""}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Mobile 1</div>
                      <div className="text-sm font-medium">
                        {cDetails?.mobile_code1 || ""} {cDetails?.c_mobi1 || "-"}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Mobile 2</div>
                      <div className="text-sm font-medium">
                        {cDetails?.mobile_code2 || ""} {cDetails?.c_mobi2 || "-"}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Email 1</div>
                      <div className="text-sm font-medium">{cDetails?.email1 || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Email 2</div>
                      <div className="text-sm font-medium">{cDetails?.email2 || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Zone</div>
                      <div className="text-sm font-medium">{cDetails?.zone || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Grade</div>
                      <div className="text-sm font-medium">{cDetails?.grade || "-"}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Boiler suit size</div>
                      <div className="text-sm font-medium">{cDetails?.boiler_suit_size || "-"}</div>
                    </div>
                  </div>
                </div>
                <div className="form-group col-md-2" style={{ marginRight: "0" }}>
                  <div className="photo-container">
                    <img src={this.state.photoUrl || noImage} alt="profile" className="photo" />
                  </div>
                  {this.state.candidateDetails.resume !== "" && (
                    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 20 }}>
                      <a href="e" onClick={this.viewResume.bind(this)}>
                        View Resume
                      </a>
                    </div>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
                <div>
                  <div className="text-xs text-gray-500 mb-1">Safety Shoe Size</div>
                  <div className="text-sm font-medium">{cDetails?.safety_shoe_size || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Height(cm)</div>
                  <div className="text-sm font-medium">{cDetails?.height || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Weight (KGS)</div>
                  <div className="text-sm font-medium">{cDetails?.weight || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">License Country</div>
                  <div className="text-sm font-medium">{cDetails?.l_countryName || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Group</div>
                  <div className="text-sm font-medium">
                    {(() => {
                      if (cDetails?.group === "1") {
                        return "Officer";
                      } else if (cDetails?.group === "2") {
                        return "Rating";
                      } else if (cDetails?.group === "6") {
                        return "IV crew";
                      }
                    })()}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Client</div>
                  <div className="text-sm font-medium">{cDetails?.vendorName || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">US Visa</div>
                  <div className="text-sm font-medium">{cDetails?.us_visa === 1 ? "Yes" : "No"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Nearest Airport</div>
                  <div className="text-sm font-medium">{cDetails?.nearestAirport}</div>
                </div>
              </div>
              <br />
              <br />
              <h3 className="text-md font-semibold text-gray-700 mb-4">Primary Address</h3>
              <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
                <div>
                  <div className="text-xs text-gray-500 mb-1">Address</div>
                  <div className="text-sm font-medium">{cDetails?.c_ad1 || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">City</div>
                  <div className="text-sm font-medium">{cDetails?.c_city || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">State</div>
                  <div className="text-sm font-medium">{cDetails?.c_state || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Country</div>
                  <div className="text-sm font-medium">{cDetails?.c_countryName || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Pin Code</div>
                  <div className="text-sm font-medium">{cDetails?.c_pin || "-"}</div>
                </div>
              </div>
              <br />
              <br />
              <h4 className="text-md font-semibold text-gray-700 mb-4">Alternate Address</h4>
              <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
                <div>
                  <div className="text-xs text-gray-500 mb-1">Address</div>
                  <div className="text-sm font-medium">{cDetails?.c_ad1 || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">City</div>
                  <div className="text-sm font-medium">{cDetails?.p_city || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">State</div>
                  <div className="text-sm font-medium">{cDetails?.p_state || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Country</div>
                  <div className="text-sm font-medium">{cDetails?.p_countryName || "-"}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1">Pin Code</div>
                  <div className="text-sm font-medium">{cDetails?.p_pin || "-"}</div>
                </div>
              </div>
              <br />

              <div className="row mt-5">
                <div className="col-md-2">
                  <div className="float-end">
                    <button className="btn btn-primary" type="button">
                      Send Application
                    </button>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Application URL"
                      aria-label="Recipient's username"
                      aria-describedby="copyApplication"
                      value={`${baseUrl}candidate/application/${cDetails.candidateId}`}
                      onChange={() => {
                        console.log("dsad");
                      }}
                    />
                    <span className="input-group-text" onClick={this.copyToClipboard.bind(this, `${baseUrl}candidate/application/${cDetails.candidateId}`)}>
                      <i className="fa fa-files-o text-white" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <Link to={`/candidate/application/${cDetails.candidateId}/view`} target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-primary" type="button">
                      View Application
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="extralargemodal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Resume Details</h5>
                <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.resumeType === "pdf" && (
                <div class="modal-body">
                  {this.state.candidateDetails.resume !== "" && (
                    <iframe src={`${downloadUrl}views/public/files/resume/${this.state.candidateDetails.resume}`} width="100%" height="500px" title="View File"></iframe>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Personal;
